import {
  AppBar,
  Toolbar,
  IconButton,
} from '@mui/material';
import BellIcon from 'icons/BellIcon';
import MailIcon from 'icons/MailIcon';
import { colors } from 'styles/colors';
import useGlobalStyles from 'styles/globalStyles';
import { useNavigate } from 'react-router-dom';
import ProfileOptions from 'components/user/UserMenu/UserMenu';
import { useAuth } from 'context/AuthContext';
import NotificationsButton from 'components/buttons/HeaderNotificationsButton/HeaderNotificationsButton';
import HeaderNotificationsButton from 'components/buttons/HeaderNotificationsButton/HeaderNotificationsButton';

export function Header() {
  const { doctor } = useAuth();
  const globalStyles = useGlobalStyles();
  const navigate = useNavigate();

  return (
    <>
      <AppBar
        position="sticky"
        elevation={0}
        sx={{
          bgcolor: 'transparent',
        }}
      >
        <Toolbar sx={{ justifyContent: 'flex-start', gap: 1.5 }}>
          {/* Notifications */}
          {!doctor && <HeaderNotificationsButton />}

          {/* Messages */}
          <IconButton
            className={globalStyles.headerIconButton}
            onClick={() => navigate('/contact')}
          >
            <MailIcon color={colors.primary} size={16} />
          </IconButton>

          {/* Profile Options */}
          <ProfileOptions />

        </Toolbar>
      </AppBar>


    </>
  );
}
